/**
 * @file Data zoom model
 */


    var DataZoomModel = require('./DataZoomModel');

    module.exports = DataZoomModel.extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomModel.js
// module id = r9WW
// module chunks = 5